export default {"src":"/_next/static/media/view-black-no.445ec567.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};